import React, { FunctionComponent } from 'react';
import SingleAddressStep from 'scenes/common/components/Steps/Addresses/SingleAddressStep';
import analytics from 'scenes/motor/analytics';
import { getOvernightParkingAddress } from 'scenes/motor/selectors';
import { MotorFullPageProps } from 'scenes/motor/types';

export const QUESTION = 'Where is the car parked overnight?';
const VALIDATION_ERROR_MESSAGE =
  'Please select the address where the car is kept overnight';
const ADDRESS_FIELD_NAME = 'overnightParkingAddress';

const OvernightParkingStep: FunctionComponent<MotorFullPageProps> = ({
  funnelState,
  onNext,
  flowType,
}) => {
  const parkingAddress = getOvernightParkingAddress(funnelState);
  return (
    <SingleAddressStep
      onNext={onNext}
      question={QUESTION}
      validationError={VALIDATION_ERROR_MESSAGE}
      stateKey={ADDRESS_FIELD_NAME}
      defaultStateValue={parkingAddress}
      onClickCallUs={() => analytics().callUs(funnelState)}
      onApiError={() => analytics().error(funnelState)}
      flowType={flowType}
    />
  );
};

export default OvernightParkingStep;
